import dedent from "dedent";
import type React from "react";
import { Button } from "../../../../components/ui/button";

export interface MatchingFormUIProps {
  candidateInfo: string;
  isLoading: boolean;
  onSubmit: (candidateInfo: string) => void;
  onCandidateInfoChange: (candidateInfo: string) => void;
}

export const MatchingFormUI: React.FC<MatchingFormUIProps> = ({
  candidateInfo,
  isLoading,
  onSubmit,
  onCandidateInfoChange,
}) => {
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (candidateInfo.trim()) {
      onSubmit(candidateInfo);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onCandidateInfoChange(e.target.value);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-base-100 rounded-xl p-6 shadow-xl"
    >
      <div className="space-y-4">
        <div>
          <label className="label">
            <span className="label-text text-base-content">
              人材情報 または 案件情報
            </span>
          </label>
          <textarea
            className="textarea textarea-bordered w-full h-48"
            placeholder={dedent`
              人材や案件の情報を入力してください。AIが内容を自動判別します。
              例：
              - React/TypeScript開発経験5年
              - GraphQL, Node.js経験あり
              - リモートワーク希望
              - 単価80-100万円/月
            `}
            value={candidateInfo}
            onChange={handleInputChange}
          />
        </div>
        <div className="flex justify-center">
          <Button
            type="submit"
            className="w-40"
            disabled={!candidateInfo.trim() || isLoading}
          >
            {isLoading ? "検索中..." : "マッチング検索"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default MatchingFormUI;
